<template>
    <div class="paginationParent">
       <button v-if="showNavigation"
       :disabled="disableBackwardNavigation"
        v-on:click.prevent="$emit('updatePage', activePage -1)"
      :class="`paginator page${disableBackwardNavigation ? ' in-active': '  active'}`">
      <i class="icon-arrow-left2"></i>
      </button>
      <button v-on:click.prevent="clickPage(page)"
      v-for="(page, index) in pagesSubArr" :key="index"
      :class="`paginator page${page === activePage ? ' active': ''}`" > {{page}} </button>
      <button v-if="showNavigation" :disabled="disableForwardNavigation"
      v-on:click.prevent="$emit('updatePage', activePage +1)"
      :class="`paginator page${disableForwardNavigation ? ' in-active': ' active'}`">
      <i class="icon-arrow-right2"></i>
      </button>
    </div>
</template>
<script>
import theme from '../../../mixins/theme';

export default {
  mixins: [theme],
  props: {
    activePage: {
      type: Number,
      required: true,
    },
    pages: {
      type: Number,
      required: true,
    },
    pagesSubArrayCount: {
      type: Number,
      default: 3,
    },
    showNavigation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    disableForwardNavigation() {
      return this.activePage + this.pagesSubArrayCount >= this.pages;
    },
    disableBackwardNavigation() {
      return (
        this.activePage - 1 + this.pagesSubArrayCount <= this.pagesSubArrayCount
      );
    },
  },
  watch: {
    activePage(newVal) {
      if (this.showNavigation) {
        this.pagesSubArr = this.pagesArray.slice(
          newVal - 1,
          this.pagesSubArrayCount + (newVal - 1),
        );
      }
    },
  },
  data() {
    return {
      pagesArray: [],
      pagesSubArr: [],
    };
  },
  mounted() {
    for (let i = 1; i < this.pages + 1; i += 1) {
      this.pagesArray.push(i);
    }
    this.pagesSubArr = this.showNavigation
      ? this.pagesArray.slice(this.activePage - 1, this.pagesSubArrayCount)
      : this.pagesArray;
  },
  methods: {
    clickPage(page) {
      this.$emit('updatePage', page);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './tables-main.scss';
</style>
